module.exports = [
	{
		"id": 289215,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=289215&type=card",
		"name": "Druid's Deliverance"
	},
	{
		"id": 289215,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=289215&type=card",
		"name": "Druid's Deliverance"
	},
	{
		"id": 289215,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=289215&type=card",
		"name": "Druid's Deliverance"
	},
	{
		"id": 369036,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=369036&type=card",
		"name": "Advent of the Wurm"
	},
	{
		"id": 369036,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=369036&type=card",
		"name": "Advent of the Wurm"
	},
	{
		"id": 397862,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=397862&type=card",
		"name": "Sunlance"
	},
	{
		"id": 397862,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=397862&type=card",
		"name": "Sunlance"
	},
	{
		"id": 420949,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=420949&type=card",
		"name": "Terramorphic Expanse"
	},
	{
		"id": 270957,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=270957&type=card",
		"name": "Growing Ranks"
	},
	{
		"id": 270957,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=270957&type=card",
		"name": "Growing Ranks"
	},
	{
		"id": 249422,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=249422&type=card",
		"name": "Séance"
	},
	{
		"id": 249422,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=249422&type=card",
		"name": "Séance"
	},
	{
		"id": 249422,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=249422&type=card",
		"name": "Séance"
	},
	{
		"id": 249422,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=249422&type=card",
		"name": "Séance"
	},
	{
		"id": 420888,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=420888&type=card",
		"name": "Skullclamp"
	},
	{
		"id": 420888,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=420888&type=card",
		"name": "Skullclamp"
	},
	{
		"id": 271156,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=271156&type=card",
		"name": "Awakening Zone"
	},
	{
		"id": 271156,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=271156&type=card",
		"name": "Awakening Zone"
	},
	{
		"id": 370661,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=370661&type=card",
		"name": "Bubbling Cauldron"
	},
	{
		"id": 370661,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=370661&type=card",
		"name": "Bubbling Cauldron"
	},
	{
		"id": 370661,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=370661&type=card",
		"name": "Bubbling Cauldron"
	},
	{
		"id": 376489,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=376489&type=card",
		"name": "Selesnya Charm"
	},
	{
		"id": 376489,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=376489&type=card",
		"name": "Selesnya Charm"
	},
	{
		"id": 376489,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=376489&type=card",
		"name": "Selesnya Charm"
	},
	{
		"id": 376489,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=376489&type=card",
		"name": "Selesnya Charm"
	},
	{
		"id": 253529,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=253529&type=card",
		"name": "Rootborn Defenses"
	},
	{
		"id": 201960,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=201960&type=card",
		"name": "Forest"
	},
	{
		"id": 201960,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=201960&type=card",
		"name": "Forest"
	},
	{
		"id": 201960,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=201960&type=card",
		"name": "Forest"
	},
	{
		"id": 201960,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=201960&type=card",
		"name": "Forest"
	},
	{
		"id": 201960,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=201960&type=card",
		"name": "Forest"
	},
	{
		"id": 201960,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=201960&type=card",
		"name": "Forest"
	},
	{
		"id": 201960,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=201960&type=card",
		"name": "Forest"
	},
	{
		"id": 376572,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=376572&type=card",
		"name": "Vitu-Ghazi, the City-Tree"
	},
	{
		"id": 244828,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=244828&type=card",
		"name": "Archon of Justice"
	},
	{
		"id": 244828,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=244828&type=card",
		"name": "Archon of Justice"
	},
	{
		"id": 244828,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=244828&type=card",
		"name": "Archon of Justice"
	},
	{
		"id": 244828,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=244828&type=card",
		"name": "Archon of Justice"
	},
	{
		"id": 106657,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=106657&type=card",
		"name": "Pull from Eternity"
	},
	{
		"id": 106657,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=106657&type=card",
		"name": "Pull from Eternity"
	},
	{
		"id": 106657,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=106657&type=card",
		"name": "Pull from Eternity"
	},
	{
		"id": 106657,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=106657&type=card",
		"name": "Pull from Eternity"
	},
	{
		"id": 413712,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=413712&type=card",
		"name": "Harmonize"
	},
	{
		"id": 413712,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=413712&type=card",
		"name": "Harmonize"
	},
	{
		"id": 413712,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=413712&type=card",
		"name": "Harmonize"
	},
	{
		"id": 413712,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=413712&type=card",
		"name": "Harmonize"
	},
	{
		"id": 369012,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=369012&type=card",
		"name": "Wake the Reflections"
	},
	{
		"id": 369012,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=369012&type=card",
		"name": "Wake the Reflections"
	},
	{
		"id": 369012,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=369012&type=card",
		"name": "Wake the Reflections"
	},
	{
		"id": 389708,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=389708&type=card",
		"name": "Sylvan Ranger"
	},
	{
		"id": 220644,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=220644&type=card",
		"name": "Ambush Viper"
	},
	{
		"id": 220644,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=220644&type=card",
		"name": "Ambush Viper"
	},
	{
		"id": 201972,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=201972&type=card",
		"name": "Plain"
	},
	{
		"id": 201972,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=201972&type=card",
		"name": "Plain"
	},
	{
		"id": 201972,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=201972&type=card",
		"name": "Plain"
	},
	{
		"id": 201972,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=201972&type=card",
		"name": "Plain"
	},
	{
		"id": 201972,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=201972&type=card",
		"name": "Plain"
	},
	{
		"id": 201972,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=201972&type=card",
		"name": "Plain"
	},
	{
		"id": 201972,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=201972&type=card",
		"name": "Plain"
	},
	{
		"id": 201972,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=201972&type=card",
		"name": "Plain"
	},
	{
		"id": 373350,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=373350&type=card",
		"name": "Deadly Recluse"
	},
	{
		"id": 373350,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=373350&type=card",
		"name": "Deadly Recluse"
	},
	{
		"id": 405117,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=405117&type=card",
		"name": "Acidic Slime"
	},
	{
		"id": 405117,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=405117&type=card",
		"name": "Acidic Slime"
	},
	{
		"id": 389708,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=389708&type=card",
		"name": "Sylvan Ranger"
	},
	{
		"id": 420781,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=420781&type=card",
		"name": "Sakura-Tribe Elder"
	},
	{
		"id": 409784,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=409784&type=card",
		"name": "Thraben Inspector"
	},
	{
		"id": 409784,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=409784&type=card",
		"name": "Thraben Inspector"
	},
	{
		"id": 409784,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=409784&type=card",
		"name": "Thraben Inspector"
	},
	{
		"id": 409784,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=409784&type=card",
		"name": "Thraben Inspector"
	},
	{
		"id": 265415,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=265415&type=card",
		"name": "Sundering Growth"
	},
	{
		"id": 265415,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=265415&type=card",
		"name": "Sundering Growth"
	},
	{
		"id": 401674,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=401674&type=card",
		"name": "Graypelt Refuge"
	},
	{
		"id": 420921,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=420921&type=card",
		"name": "Jungle Shrine"
	},
	{
		"id": 420921,
		"imageUrl": "http://gatherer.wizards.com/Handlers/Image.ashx?multiverseid=420921&type=card",
		"name": "Jungle Shrine"
	}
];


/*****************
 ** WEBPACK FOOTER
 ** ./decks/token.json
 ** module id = 439
 ** module chunks = 0
 **/